import {Component, ViewChild, OnInit, TemplateRef, EventEmitter, Output, Pipe, PipeTransform } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { ModalService } from '../../../services/modal.service';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TaxasAdministrativas } from '../../../model/taxasadministrativas';
import { CadastrosService } from '../../../services/cadastros.service';
import { OperacaoEnum } from '../../../model/enumeration/operacaoEnum';
import { BandeiraEnum } from '../../../model/enumeration/bandeiraEnum';
import { CondicaoPagamentoEnum } from '../../../model/enumeration/condicaoPagamentoEnum';
import { AdquirenteEnum } from '../../../model/enumeration/adquirenteEnum';

@Component({
  selector: 'app-detalhes-taxasadministrativas',
  templateUrl: 'taxasadministrativas-detalhes.component.html',
})

export class TaxasAdministrativasDetalhesComponent implements OnInit{

  @ViewChild('modaltaxasadministrativas', {static: false}) public modaltaxasadministrativas: ModalDirective;

  sub: boolean = false;
  _taxasadministrativas: TaxasAdministrativas = new TaxasAdministrativas();
  @Output() loadtaxasadministrativas = new EventEmitter();
  titulo: string = "Nova Taxa Administrativa";
  movSubSalvar: Subscription;
  movSubAlterar: Subscription;
  clientes: any[];
  adquirentes: any[];
  metodo : string;

  operacoes = Object.keys(OperacaoEnum).map(key => OperacaoEnum[key]);
  bandeiras = Object.keys(BandeiraEnum).map(key => BandeiraEnum[key]);
  // adquirentes = Object.keys(AdquirenteEnum).map(key => AdquirenteEnum[key]);
  condicoes = Object.keys(CondicaoPagamentoEnum).map(key => CondicaoPagamentoEnum[key]);

  movSub: Subscription;
  movSub1: Subscription;

  constructor(
    private modalService: ModalService,
    private toastr: ToastrService,
    private cadastrosService: CadastrosService) {

  }

  ngOnInit() {

    if(this.sub == false){

      this.sub = true;

      this.modalService.modalDetalhesTaxasAdministrativas.subscribe(
        (p: TaxasAdministrativas) => {

          if(p == null){
            this.titulo = "Nova Taxa Administrativa"
            this._taxasadministrativas = new TaxasAdministrativas();
          }else{
            this.titulo = "Editar Taxa Administrativa"
            this._taxasadministrativas = p;
          }

          this.limpaModal();

          this.getClientes();
          this.getAdquirentes();
          this.modaltaxasadministrativas.show();

        }, error => {
          console.log(error.message);
        }
      );
    }

  }

  async getClientes(){

    this.clientes = [];

    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }

    if (!this.movSub || this.movSub.closed){

      this.movSub = this.cadastrosService.listar("cliente/list?id=PANASONIC").subscribe(
        (result: any) =>{

          this.clientes =  result;
          console.log(result);

       },error=>{
            console.log(error);
       });

    }

  }


  async getAdquirentes(){

    this.adquirentes = [];

    if (this.movSub1 && this.movSub1.closed == false){
      this.movSub1.unsubscribe();
    }

    if (!this.movSub1 || this.movSub1.closed){

      this.movSub1 = this.cadastrosService.listar("adquirente/list").subscribe(
        (result: any) =>{

          this.adquirentes =  result;
          console.log(result);

       },error=>{
            console.log(error);
       });

    }

  }



  hideModal(){
    this.modaltaxasadministrativas.hide();
    this.loadtaxasadministrativas.emit();
  }

  limpaModal(){
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }

  onSubmit(form: NgForm) {

    if (!form.valid) {
      return;
    }

    if(this.titulo == "Editar Taxa Administrativa"){
      this.atualizar();
    }else{
      this.salvar();
    }

    form.reset();
  }

  salvar(){
    console.log( "$$$$$$$$$$$$$$$$$$$$$ BTN SALVAR $$$$$$$$$$$$$$$$$$$$$ ")
    let objtaxasadministrativas = JSON.parse(JSON.stringify(this._taxasadministrativas));

    if ( this._taxasadministrativas.id === undefined ) {
      this.metodo = "insert";
    } else {
      this.metodo = "update";
    }

    this.cadastrosService.salvar("taxasadministrativas/" + this.metodo, objtaxasadministrativas).subscribe(
      (result) =>{

        this.toastr.success('Taxa Administrativa cadastrada com sucesso!', 'Sucesso!');
        console.log(result);

        this.hideModal();

      },
      error=> {

        this.toastr.error(error.message, 'Erro!');
        console.log(error);

        this.hideModal();
      }

    );



  }

  atualizar(){

    let objtaxasadministrativas = JSON.parse(JSON.stringify(this._taxasadministrativas));

    this.cadastrosService.atualizar("taxasadministrativas/update", objtaxasadministrativas, objtaxasadministrativas.id).subscribe(
      (result) =>{

        this.toastr.success('Taxa Administrativa atualizado com sucesso!', 'Sucesso!');
        console.log(result);

        this.hideModal();

      },
      error=> {

        this.toastr.error(error.message, 'Erro!');
        console.log(error);

        this.hideModal();
      }

    );
  }
}
